<template>
  <v-container class="py-0">
    <v-alert v-if="client && client.isArchived" text prominent outlined color="exceptional" icon="mdi-alert">
      <div class="font-weight-bold">Important!</div>
      <div>This is an archived client.</div>
    </v-alert>
    <v-alert v-if="client && !client.isArchived && clientIsMissingMainContact" text prominent outlined color="exceptional" icon="mdi-alert">
      <div class="font-weight-bold">Invalid Profile Data.</div>
      <div> Open this client in HawkSoft and update the personal profile.</div>
    </v-alert>
    <v-row v-if="client">
      <v-col class="pa-0">
        <template v-if="client.isBusiness">
          <div v-if="client.businessName">
            <div class="title">{{ client.businessName }}</div>
            <div v-if="client.dba" class="subtitle-1">(DBA: {{ client.dba }})</div>
          </div>
          <div v-else-if="client.dba">
            <div class="title">DBA: {{ client.dba }}</div>
            <div class="subtitle-1">{{ client.mainContactName }}</div>
          </div>
        </template>
        <template v-else>
          <div class="title">{{ client.mainContactName }}</div>
          <div v-if="hasSecondMainContact" class="title">{{ client.secondMainContactName }}</div>
          <div v-if="client.moreMainContacts" class="caption">View the <a @click="switchToPeopleTab">people tab</a> to see all profiles</div>
        </template>
        <div v-if="client.clientSince" class="caption">
          <span>{{ clientSince }}</span>
        </div>
        <div class="caption">
          <span>{{ clientStatus }}</span> |
          <span>{{ clientType }}</span> |
          <span>{{ customerType }}</span>
        </div>
        <div class="caption">
          <span>
            Producer: <span v-if="client">{{ client.producer }}</span>
          </span> |
          <span>
            CSR: <span v-if="client">{{ client.csr }}</span>
          </span>
        </div>
        <div v-if="client && client.officeName" class="caption">
          <span>Office: {{ client.officeName }}</span>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="8" class="px-1">
        <v-divider />
      </v-col>

      <v-col cols="12" md="8" class="pa-0">
        <template v-if="client && client.primaryContact">
          <Contact :contact="client.primaryContact" @clicked="handleClick" />
        </template>
      </v-col>

      <v-col cols="12" md="8" class="px-0 pt-1">
        <div v-if="clientHasPhysicalAddress" class="py-1">
          <Address :address="client.physicalAddress" />
        </div>
        <div v-if="clientHasMailingAddress" class="py-1">
          <Address :address="client.mailingAddress" />
        </div>
        <div v-if="!clientHasMailingAddress && !clientHasPhysicalAddress">
          <span>No Address</span>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style>
</style>

<script>
import analyticsService from '@/services/shared/analyticsService.js';
import displayFormatterService from '@/services/shared/displayFormatterService.js';
import { mapState } from 'vuex';
import Address from '@/components/Client/Address.vue';
import Contact from '@/components/Client/Contact.vue';

export default {
  components: {
    Address,
    Contact
  },
  data: function () {
    return {
      clientTypes: {
        0: 'None',
        65: 'AgentOrEmployee',
        67: 'Customer',
        69: 'PersonalContact',
        71: 'AgencyContact',
        73: 'Carrier',
        77: 'EmergencyContact',
        79: 'Other',
        86: 'Vendor'
      },
      loading: true
    };
  },
  computed: {
    ...mapState(['client']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    clientIdDisplay: function () {
      return this.clientId.padStart(8, 0);
    },
    clientStatus: function () {
      if ((this.client || null) === null) return 'Unknown Client Status';
      if (this.client.isActive) return 'Active';
      if (this.client.isProspect) return 'Prospect';
      if (this.client.isLead) return 'Lead';
      if (this.client.isDeadFile) return 'Dead File';

      return 'Unknown Client Status';
    },
    clientType: function () {
      if ((this.client || null) === null) return 'Unknown Client Type';
      return this.clientTypes[this.client.clientType];
    },
    customerType: function () {
      if ((this.client || null) === null) return 'Unknown Customer Type';
      var types = [];
      if (this.client.isPersonal) types.push('Personal');
      if (this.client.isCommercial) types.push('Commercial');
      if (this.client.isLifeHealth) types.push('Life/Health');
      if (this.client.allowCrossSell) types.push('Allow Cross Selling');
      if (this.client.doNotMarket) types.push('Do Not Market');

      return types.join(', ');
    },
    hasSecondMainContact: function () {
      return (this.client.secondMainContactName || null) !== null && this.client.secondMainContactName !== '';
    },
    clientIsMissingMainContact: function () {
      if ((this.client || null) === null) return true;
      return (this.client.mainContactName || null) === null;
    },
    clientHasMailingAddress: function () {
      return this.client && this.client.mailingAddress;
    },
    clientHasPhysicalAddress: function () {
      return this.client && this.client.physicalAddress;
    },
    clientSince: function () {
      if ((this.client.clientSince || null) === null) return '';
      return 'Client Since: ' + displayFormatterService.formatDate(this.client.clientSince);
    }
  },
  methods: {
    handleClick: function (clickType) {
      if (clickType === 'call') {
        analyticsService.sendEvent(this.$gtag, 'Call', 'Client', 'Client Info Call');
      }
    },
    switchToPeopleTab: function () {
      this.$emit('force-tab-change', 2);
    }
  }
};
</script>
